import { inject } from "@angular/core";
import { Router, CanActivateFn } from "@angular/router";
import { map } from "rxjs";
import { AuthService } from "./auth.service";

export const AdminGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (!authService.isAuthenticated()) {
    router.navigate(["/"]);
    return false;
  }
  authService.authenticated();
  return authService.validateTokenWithServer().pipe(
    map((ok) => {
      if (ok) {
        return true;
      }
      if (!authService.isAuthenticated()) {
        return false;
      }
      router.navigate(["/"]);
      return false;
    })
  );
};
